import * as types from './types'
/**
 * @function 存储筛选信息
 * @param commit
 * @param data
 */
export const saveTeachAssistantInfo = ({ commit }, data) => {
  commit(types.SET_TEACH_ASSISTANT_INFO, data)
}

/**
 * @function 存储课程图文详情
 * @param commit
 * @param data
 */
export const saveCourseRichContent = ({ commit }, data) => {
  commit(types.SET_COURSE_CONTENT, data)
}

/**
 * @function 存储当前选择的门店
 * @param commit
 * @param data
 */
export const saveAssistantStoreInfo = ({ commit }, data) => {
  commit(types.SET_TEACH_ASSISTANT_STORE_INFO, data)
}

/**
 * @function 存储课程管理列表请求参数
 * @param commit
 * @param data
 */
export const saveClassListReq = ({ commit }, data) => {
  commit(types.SET_CLASS_LIST_REQUEST, data)
}
